import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useContext } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FooterLogin from '../components/footer/FooterLoginBlock';
import HeaderMobileMenu from '../components/header/HeaderMobileMenu';
import { GIFT_LAYOUT } from '../config/constants/layout-types';
import ThemeContext from '../providers/ThemeProvider';
import { getClientSideLayoutEssentials } from '../redux/actions/clientRender';

const GiftLayout = ({ children, extraClasses }) => {
  const user = useSelector((state) => state.user);
  const router = useRouter();
  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);

  useEffect(() => {
    dispatch(getClientSideLayoutEssentials(user, GIFT_LAYOUT));
  }, [dispatch, user.isAuthenticated]);

  const content = children;

  return (
    <>
      <div className={extraClasses}>
        <HeaderMobileMenu path={router.asPath} />
        <div className="app app--full-height" id="main-view">
          {content}
        </div>
        <FooterLogin />
      </div>
      <style jsx>
        {`
          :global(.loading-placeholder__side) {
            display: none;
          }
          :global(.loading-placeholder .loading-placeholder__box) {
            padding-top: 56%;
          }
          :global(.loading-placeholder .loading-placeholder__box:before) {
            bottom: 0;
          }
          :global(.loading-placeholder .loading-placeholder__box:after) {
            display: none;
          }

          @media (min-width: ${theme.breakpoints.mdUp}) {
            :global(.loading-placeholder__main) {
              margin: 0 auto;
            }
          }
        `}
      </style>
    </>
  );
};

GiftLayout.propTypes = {
  children: PropTypes.array,
  extraClasses: PropTypes.string,
};

export default GiftLayout;
